import {
  Link as ChakraLink,
  HTMLChakraProps,
  LinkProps,
} from "@chakra-ui/react";
import React, { forwardRef } from "react";

import { useColors } from "./useColors";
import { useVariant } from "./Variant";

const LinkInternal = (
  props: HTMLChakraProps<"a"> &
    LinkProps & {
      icon?: string;
    },
  ref: React.ForwardedRef<HTMLAnchorElement> | null,
) => {
  const { href, children, icon: icon_, ...otherProps } = props;

  const isExternal = !!href?.startsWith("http");
  const isAnchor = !!href?.startsWith("#");

  const icon = icon_ ?? (isExternal ? "°" : isAnchor ? "#" : "†");
  const isIconSmall = !isExternal;

  const { linkColor, linkBackground } = useColors();
  const { openInternalLinksInNewTab } = useVariant();

  return (
    <ChakraLink
      color={linkColor}
      href={href}
      isExternal={isExternal || (!isAnchor && openInternalLinksInNewTab)}
      ref={ref}
      {...otherProps}
      sx={{
        ...otherProps.sx,
        "&:hover": {
          textDecoration: "none",
          bg: linkBackground,
          ...(otherProps.sx?.["&:hover" as keyof typeof otherProps.sx] ?? {}),
        },
        "&:focus": {
          bg: linkBackground,
          ...(otherProps.sx?.["&:focus" as keyof typeof otherProps.sx] ?? {}),
        },
        "&::after": {
          ...(icon && {
            content: `"${icon}"`,
            ...(isIconSmall && {
              fontSize: "0.75em",
              verticalAlign: "super",
            }),
          }),
          ...(otherProps.sx?.["&::after" as keyof typeof otherProps.sx] ?? {}),
        },
      }}
    >
      {children}
    </ChakraLink>
  );
};

export const Link = forwardRef(LinkInternal);
